import {useDebounce} from './use-debounce';

export {useDebounce};

export default useDebounce;
